import React, { PureComponent } from 'react'
import {
  string, bool, func, shape, instanceOf,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import CreateAccountDetail from './components/CreateAccount'
import { ageValidatorBuilder } from '../../shared/validator'
import { calculateAge, filterDate } from '../../shared/utils/commonUtils'
import { CreateAccountFormDefaultTypes, CreateAccountFormPropTypes } from './components/CreateAccount/CreateAccountForm'

const ADULT_AGE = 18

class CUISignupV2 extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    configureTrack: func.isRequired,
    hideCollectingConsents: bool,
    fields: shape({
      email: string,
      firstName: string,
      lastName: string,
      dob: instanceOf(Date),
      countryCode: string,
    }),

    ...CreateAccountFormPropTypes,
    amEighteen: bool,
    showIfError: bool,
  }

  static defaultProps = {
    hideCollectingConsents: true,
    fields: {},
    ...CreateAccountFormDefaultTypes,
    amEighteen: false,
    showIfError: true,
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'CUISignupV2',
      widget: 'cui_signup_v2',
      pageType: 'CUI Signup V2',
    })
  }

  render() {
    const {
      i18n, fields, amEighteen,
      // CreateAccountForm
      firstNameField, lastNameField, dobField, countryField, emailField,
    } = this.props
    const {
      firstName, lastName, dob, countryCode, email,
    } = fields
    const adultDOBValidator = ageValidatorBuilder({
      min: { value: ADULT_AGE, errMsg: i18n('passport.error.validation.youngAge', { 0: ADULT_AGE }) },
    })

    const initDob = filterDate(dobField.value) || filterDate(dob)
    return (
      <CreateAccountDetail
        {...this.props}
        firstNameField={{ hidden: !!(firstName && lastName), ...firstNameField }}
        lastNameField={{ hidden: !!(firstName && lastName), ...lastNameField }}
        dobField={{
          customerValidator: adultDOBValidator,
          optional: amEighteen,
          hidden: (!initDob && amEighteen) || (initDob && calculateAge(initDob) >= 18),
          ...dobField,
          // Extract init dob from Component to Widget
          value: initDob,
        }}
        countryField={{ hidden: countryCode, ...countryField }}
        emailField={{ changeAble: !email, editAble: !email, ...emailField }}
      />
    )
  }
}

export default withI18n(CUISignupV2)
